(() => {
  const triggerSelector = '.product-card__quick-buy > .button[aria-controls^="product-quick-buy-"]';
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mouseOpenedTriggers = new WeakSet();

  /*
   * Stretch returns keyboard focus to the element that opened a modal.
   * For a mouse-opened product quick-buy this can keep the card's native
   * focus state visible after the modal closes. We remember mouse opens
   * only, then remove that restored focus when it comes back later.
   * Keyboard navigation keeps Stretch's native focus behavior untouched.
   */
  document.addEventListener('click', (event) => {
    if (!finePointer.matches) return;

    const trigger = event.target.closest?.(triggerSelector);
    if (!trigger) return;

    mouseOpenedTriggers.add(trigger);
  }, true);

  document.addEventListener('focusin', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const trigger = target.closest(triggerSelector);
    if (!trigger || !mouseOpenedTriggers.has(trigger)) return;

    requestAnimationFrame(() => {
      if (document.activeElement === trigger) {
        trigger.blur();
      }

      mouseOpenedTriggers.delete(trigger);
    });
  }, true);

  document.addEventListener('keydown', () => {
    document.querySelectorAll(triggerSelector).forEach((trigger) => {
      mouseOpenedTriggers.delete(trigger);
    });
  }, true);
})();